import React, { useEffect, useRef } from 'react'; // Import useRef
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import useAuthStore from '../store/useAuthStore';
import { axiosInstance } from '../lib/axiosInstance';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

const GoogleCallback = () => {
  const { setGoogleAuth } = useAuthStore();
  const location = useLocation();
  const navigate = useNavigate();
  const authRequestSent = useRef(false); // Create a ref to track the API call

  useEffect(() => {
    // Prevent the effect from running on the second mount in Strict Mode
    if (authRequestSent.current) {
      return;
    }
    authRequestSent.current = true; // Set the flag to true immediately

    const params = new URLSearchParams(location.search);
    const code = params.get('code');

    const authStatus = sessionStorage.getItem('googleAuthStatus');
    sessionStorage.removeItem('googleAuthStatus');

    if (authStatus !== 'in-progress') {
      toast.error('Invalid authentication flow. Please try logging in again.');
      sessionStorage.removeItem('googleAuthRedirect');
      navigate('/login?type=customer', { replace: true });
      return;
    }

    if (code) {
      const handleAuth = async (authCode) => {
        try {
          const response = await axiosInstance.post('/customer/google/callback', { code: authCode });
          if (response.data.success) {
            const { token, user: googleUser } = response.data;
            setGoogleAuth(googleUser, token);

            const redirectPath = sessionStorage.getItem('googleAuthRedirect');
            sessionStorage.removeItem('googleAuthRedirect');

            toast.success("Authentication successful!");
            navigate(redirectPath || '/customer/projectinvite', { replace: true });

          } else {
            toast.error(response.data.message || 'Google login failed.');
            sessionStorage.removeItem('googleAuthRedirect');
            navigate('/login?type=customer', { replace: true });
          }
        } catch (error) {
          const errorMessage = error.response?.data?.message || error.response?.data?.detail || error.message || 'Google login failed.';
          toast.error(errorMessage);
          console.error('Google Callback Error:', error);
          sessionStorage.removeItem('googleAuthRedirect');
          navigate('/login?type=customer', { replace: true });
        }
      };
      handleAuth(code);
    } else {
      toast.error('Invalid Google callback. No authorization code found.');
      sessionStorage.removeItem('googleAuthRedirect');
      navigate('/login?type=customer', { replace: true });
    }
    // The dependency array can be simplified as the ref handles the re-run logic
  }, [location, navigate, setGoogleAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center">
        <AiOutlineLoading3Quarters className="animate-spin text-4xl text-blue-500 mb-4" />
        <p className="text-gray-700">Finalizing authentication...</p>
      </div>
    </div>
  );
};

export default GoogleCallback;